// #################################################################################################### Axeptio
window._axcb = window._axcb || [];
window._axcb.push(function(sdk){
  let style = document.createElement('style');
  let css = '';
  css += '#axeptio_main_button svg path:first-of-type {fill: #f1e7d5 !important;}';
  css += '.ax-discardButton {margin: 0; padding: 0; background: none; border: none; box-shadow: none; color: #000; top: 5px !important; font-size: 11px; z-index: 1000; left: 20px; opacity: 0.4 !important;}';
  css += '#axeptio_btn_acceptAll {background-color: #f1e7d5 !important;color: #333 !important;font-weight: normal !important;}';
  style.innerHTML = css;
  document.querySelector('#axeptio_overlay .needsclick').shadowRoot.appendChild(style);
});
// #################################################################################################### ???
document.addEventListener("DOMContentLoaded", function() {
  
});
